import { render, staticRenderFns } from "./DevBpbjStandardInfoForm.vue?vue&type=template&id=42fff9b8&"
import script from "./DevBpbjStandardInfoForm.vue?vue&type=script&lang=js&"
export * from "./DevBpbjStandardInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports